import * as actionNameTypes from "./actionType";

export const fetchMessage = payload => ({
  type: actionNameTypes.fetchMessageType,
  payload
});

export const fetchAllMessage = payload => ({
  type: actionNameTypes.fetchAllMessageType,
  payload
});

export const storeMessage = payload => ({
  type: actionNameTypes.storeAllMessageType,
  payload
});

export const messageTabChange = payload => ({
  type: actionNameTypes.selectionChangeType,
  payload
});

export const messageFullDisplay = () => ({
  type: actionNameTypes.messageFullDisplayType
});

export const messageFullDisplayInitial = () => ({
  type: actionNameTypes.messageFullDisplayInitialType
});
